import { Text } from '../../types/theme'

export const text: Text = {
	size: {
		xl: 40,
		lg: 24,
		md: 16,
		sm: 14,
		xs: 12,
	},
	fontFamily: [
		'FedraSansBarilan',
		'Roboto',
		'"Helvetica Neue"',
		'Arial',
		'sans-serif',
		'"Apple Color Emoji"',
		'"Segoe UI Emoji"',
		'"Segoe UI Symbol"',
	].join(','),
};
